import type { ProcessTemplateTaskType } from '@econtractor/types';
import { getProcessNextTasks, processTaskInstanceKey } from './nextTask';

export const wouldCreateProcessCycle = (
    tasks: ProcessTemplateTaskType[],
    sourceTemplateId: number,
    sourceDtId: number,
    targetTemplateId: number,
    targetDtId: number,
): boolean => {
    const sourceKey = processTaskInstanceKey(sourceTemplateId, sourceDtId);
    const targetKey = processTaskInstanceKey(targetTemplateId, targetDtId);
    if (sourceKey === targetKey) return true;

    const outgoing = new Map<string, string[]>();
    for (const task of tasks) {
        outgoing.set(
            processTaskInstanceKey(task.templateId, task.dtId),
            getProcessNextTasks(task.processData).map((link) => processTaskInstanceKey(link.templateId, link.dtId)),
        );
    }

    const stack = [targetKey];
    const visited = new Set<string>();
    while (stack.length > 0) {
        const currentKey = stack.pop();
        if (currentKey == null) continue;
        if (currentKey === sourceKey) return true;
        if (visited.has(currentKey)) continue;
        visited.add(currentKey);
        for (const nextKey of outgoing.get(currentKey) || []) stack.push(nextKey);
    }
    return false;
};
